import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import {
  FormControl,
  Grid,
  MenuItem,
  NativeSelect,
  Paper,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import PeopleIcon from "@mui/icons-material/People";
import { useNavigate } from "react-router-dom";
import FiberNewIcon from "@mui/icons-material/FiberNew";
import ApartmentIcon from "@mui/icons-material/Apartment";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import AddCommentIcon from "@mui/icons-material/AddComment";
import {
  useGetDashboardDataMutation,
  useLazyPostUserGraphQuery,
  useLazyPostVendorGraphQuery,
  useLazyPostOrderGraphQuery,
  useLazyPostProductGraphQuery,
  useLazyPostRevenueGraphQuery,
} from "../../services/dashboard";
import { DashboardData } from "../../types/General";
import moment from "moment";
import { LineChart } from "../../components";
import { errorToast, getFromStorage } from "../../helpers";
import Loader from "../../helpers/constants/Loader";
import useTranslation from "../../hooks/Translation";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#204e33" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));
let DATA = 100;
const DashBoard = () => {
  const [dashboardData] = useGetDashboardDataMutation();
  const t = useTranslation();
  const [data, setData] = useState<DashboardData>();
  const [userGraphData, setUserGraphData] = useState<any>([]);
  const [vendorGraphData, setVendorGraphData] = useState<any>([]);
  const [orderGraphData, setOrderGraphData] = useState<any>([]);
  const [productGraphData, setProductGraphData] = useState<any>([]);
  const [revenueGraphData, setRevenueGraphData] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [userGraphApi] = useLazyPostUserGraphQuery();
  const [vendorGraphApi] = useLazyPostVendorGraphQuery();
  const [orderGraphApi] = useLazyPostOrderGraphQuery();
  const [productGraphApi] = useLazyPostProductGraphQuery();
  const [revenueGraph] = useLazyPostRevenueGraphQuery();

  const company = [
    { label: "Jan", value: 1200 },
    { label: "Feb", value: 900 },
    { label: "March", value: 1500 },
    { label: "April", value: 700 },
    { label: "May", value: 1100 },
    { label: "June", value: 600 },
    { label: "July", value: 1300 },
    { label: "August", value: 800 },
  ];

  const [selectedType1, setSelectedType1] = useState<string>("1");

  const [selectedType2, setSelectedType2] = useState<string>("1");
  const [selectedType4, setSelectedType4] = useState<string>("1");
  const [selectedType3, setSelectedType3] = useState<string>("1");
  const [selectedType5, setSelectedType5] = useState<string>("1");
  const [selectedType6, setSelectedType6] = useState<string>("1");
  const handleChange = (event: SelectChangeEvent<string>) => {
    setSelectedType1(event.target.value);
  };
  const handleChange2 = (event: SelectChangeEvent<string>) => {
    setSelectedType2(event.target.value);
  };
  const handleChange3 = (event: SelectChangeEvent<string>) => {
    setSelectedType3(event.target.value);
  };
  const handleChange4 = (event: SelectChangeEvent<string>) => {
    setSelectedType4(event.target.value);
  };
  const handleChange5 = (event: SelectChangeEvent<string>) => {
    setSelectedType5(event.target.value);
  };
  const handleChange6 = (event: SelectChangeEvent<string>) => {
    setSelectedType6(event.target.value);
  };
  // <-----------------------fetch user graph------------------------->
  const callUserGraph = async () => {
    try {
      const response = await userGraphApi({
        interval: Number(selectedType1),
      }).unwrap();
      if (response.status === 200) {
        const apiData = response?.data;
        const formattedData = Object.keys(apiData).map((key) => ({
          label: key,
          value: apiData[key],
        }));
        setUserGraphData(formattedData);
      }
    } catch (e) {
      console.error("Error fetching user graph data:", e);
    }
  };

  // <-----------------------fetch user graph------------------------->
  // <-----------------------fetch vendor graph------------------------->
  const callVendorGraph = async () => {
    try {
      const response = await vendorGraphApi({
        interval: Number(selectedType2),
      }).unwrap();
      if (response.status === 200) {
        const apiData = response?.data;
        const formattedData = Object.keys(apiData).map((key) => ({
          label: key,
          value: apiData[key],
        }));
        setVendorGraphData(formattedData);
      }
    } catch (e) {
      console.error("Error fetching user graph data:", e);
    }
  };

  // <-----------------------fetch vendor graph------------------------->
  // <-----------------------fetch order graph------------------------->
  const callOrderGraph = async () => {
    try {
      const response = await orderGraphApi({
        interval: Number(selectedType3),
      }).unwrap();
      if (response.status === 200) {
        const apiData = response?.data;
        const formattedData = Object.keys(apiData).map((key) => ({
          label: key,
          value: apiData[key],
        }));
        setOrderGraphData(formattedData);
      }
    } catch (e) {
      console.error("Error fetching user graph data:", e);
    }
  };
  // <-----------------------fetch order graph------------------------->
  // <-----------------------fetch product graph------------------------->
  const callProductGraph = async () => {
    try {
      const response = await productGraphApi({
        interval: Number(selectedType5),
      }).unwrap();
      if (response.status === 200) {
        const apiData = response?.data;
        const formattedData = Object.keys(apiData).map((key) => ({
          label: key,
          value: apiData[key],
        }));
        setProductGraphData(formattedData);
      }
    } catch (e) {
      console.error("Error fetching user graph data:", e);
    }
  };
  // <-----------------------fetch order graph------------------------->

  const fetchDashBoardData = async () => {
    setLoading(true);
    try {
      const response = await dashboardData({}).unwrap();
      if (response?.status === 200) {
        setLoading(false);
        setData(response?.data);
      }
    } catch (e: any) {
      setLoading(false);
      errorToast(e?.message || "");
    }
  };

  const callRevenueGraph = async () => {
    try {
      const response = await revenueGraph({
        interval: Number(selectedType6),
      }).unwrap();
      if (response.status === 200) {
        const apiData = response?.data;
        const formattedData = Object.keys(apiData).map((key) => ({
          label: key,
          value: apiData[key],
        }));
        setRevenueGraphData(formattedData);
      }
    } catch (e) {
      console.error("Error fetching user graph data:", e);
    }
  };

  const graphUsersData = {
    labels:
      userGraphData?.length !== 0
        ? userGraphData?.map((item: any) => item.label)
        : [],
    datasets: [
      {
        label: t.main.totalCustomers,
        data:
          userGraphData?.length !== 0
            ? userGraphData?.map((item: any) => item.value)
            : [],
        borderColor: "black",
        backgroundColor: "#AAAAAA",
      },
    ],
  };
  const graphVendorData = {
    labels:
      vendorGraphData?.length !== 0
        ? vendorGraphData?.map((item: any) => item.label)
        : [],
    datasets: [
      {
        label: t.main.totalVendors,
        data:
          vendorGraphData?.length !== 0
            ? vendorGraphData?.map((item: any) => item.value)
            : [],
        borderColor: "black",
        backgroundColor: "#AAAAAA",
      },
    ],
  };
  const graphOrderData = {
    labels:
      orderGraphData?.length !== 0
        ? orderGraphData?.map((item: any) => item.label)
        : [],
    datasets: [
      {
        label: t.main.totalOrders,
        data:
          orderGraphData?.length !== 0
            ? orderGraphData?.map((item: any) => item.value)
            : [],
        borderColor: "black",
        backgroundColor: "#AAAAAA",
      },
    ],
  };

  const graphRevenueData = {
    labels:
      revenueGraphData?.length !== 0
        ? revenueGraphData?.map((item: any) => item.label)
        : [],
    datasets: [
      {
        label: t.main.totalRevenue,
        data:
          revenueGraphData?.length !== 0
            ? revenueGraphData?.map((item: any) => item.value)
            : [],
        borderColor: "black",
        backgroundColor: "#AAAAAA",
      },
    ],
  };

  // const graphRevenueData = {
  //   labels: company?.map((item: any) => item.label),
  //   datasets: [
  //     {
  //       label: "Total Revenue",
  //       data:
  //         company.length !== 0 ? company?.map((item: any) => item.value) : [],
  //       borderColor: "black",
  //       backgroundColor: "#AAAAAA",
  //     },
  //   ],
  // };
  const graphProductData = {
    labels:
      productGraphData?.length !== 0
        ? productGraphData?.map((item: any) => item.label)
        : [],
    datasets: [
      {
        label: t.main.totalProductsListed,
        data:
          productGraphData?.length !== 0
            ? productGraphData?.map((item: any) => item.value)
            : [],
        borderColor: "black",
        backgroundColor: "#AAAAAA",
      },
    ],
  };

  const navigate = useNavigate();
  useEffect(() => {
    fetchDashBoardData();
  }, []);
  useEffect(() => {
    callUserGraph();
  }, [selectedType1]);
  useEffect(() => {
    callVendorGraph();
  }, [selectedType2]);
  useEffect(() => {
    callOrderGraph();
  }, [selectedType3]);
  useEffect(() => {
    callProductGraph();
  }, [selectedType5]);
  useEffect(() => {
    callRevenueGraph();
  }, [selectedType6]);
  return (
    <div className="main_loyout">
      <div className="dashboard">
        <h1 className="mn_hdng">{t.sideBar.dashboard}</h1>
      </div>

      <Loader isLoad={loading} />

      <Grid container spacing={2} className="dashGrid">
        <Grid item lg={3} md={3} sm={6} xs={12}>
          <Item
            className="cards dashGrid_item"
            onClick={() => navigate("/manage-users")}
          >
            <PeopleIcon className="svg_icn" />
            <div>
              <h3>{t.main.totalCustomers}</h3>
              <h4 className="mn_hdng">{data?.totalCustomer}</h4>
            </div>
          </Item>
        </Grid>
        <Grid item lg={3} md={3} sm={6} xs={12}>
          <Item
            className="cards dashGrid_item"
            onClick={() => navigate("/manage-vendors")}
          >
            <SupportAgentIcon className="svg_icn" />
            <div>
              <h3>{t.main.totalVendors}</h3>
              <h4 className="mn_hdng">{data?.totalVendors}</h4>
            </div>
          </Item>
        </Grid>
        <Grid item lg={3} md={3} sm={6} xs={12}>
          <Item
            className="cards dashGrid_item"
            onClick={() => navigate("/manage-Order")}
          >
            <ApartmentIcon className="svg_icn" />
            <div>
              <h3>{t.main.totalOrders}</h3>
              <h4 className="mn_hdng">{data?.totalOrders}</h4>
            </div>
          </Item>
        </Grid>
        <Grid item lg={3} md={3} sm={6} xs={12}>
          <Item
            className="cards dashGrid_item"
            onClick={() => navigate("/manage-Order")}
          >
            <ApartmentIcon className="svg_icn" />
            <div>
              <h3>{t.main.totalOrders}</h3>
              <h4 className="mn_hdng">{data?.ongoingOrders}</h4>
            </div>
          </Item>
        </Grid>
        <Grid item lg={3} md={3} sm={6} xs={12}>
          <Item
            className="cards dashGrid_item"
            onClick={() => navigate("/manage-Order")}
          >
            <ApartmentIcon className="svg_icn" />
            <div>
              <h3>{t.main.completedOrders}</h3>
              <h4 className="mn_hdng">{data?.completedOrders}</h4>
            </div>
          </Item>
        </Grid>
        <Grid item lg={3} md={3} sm={6} xs={12}>
          <Item
            className="cards dashGrid_item"
            onClick={() => navigate("/manage-Order")}
          >
            <ApartmentIcon className="svg_icn" />
            <div>
              <h3>{t.main.cancelledOrders}</h3>
              <h4 className="mn_hdng">{data?.cancelledOrders}</h4>
            </div>
          </Item>
        </Grid>

        {/* <Grid item lg={3} md={3} sm={6} xs={12}>
          <Item className="cards dashGrid_item">
            <SubscriptionsIcon className="svg_icn" />
            <div>
              <h3>New Reviews</h3>
              <h4 className="mn_hdng">{DATA}</h4>
            </div>
          </Item>
        </Grid> */}

        <Grid item lg={3} md={3} sm={6} xs={12}>
          <Item
            className="cards dashGrid_item"
            onClick={() => navigate("/manage-categories")}
          >
            <AddCommentIcon className="svg_icn" />
            <div>
              <h3>{t.main.totalCategories}</h3>
              <h4 className="mn_hdng">{data?.totalCategories}</h4>
            </div>
          </Item>
        </Grid>

        <Grid item lg={3} md={3} sm={6} xs={12}>
          <Item
            className="cards dashGrid_item"
            onClick={() => navigate("/manage-categories")}
          >
            <AddCommentIcon className="svg_icn" />
            <div>
              <h3>{t.main.totalSubCategories}</h3>
              <h4 className="mn_hdng">{data?.totalSubCategories}</h4>
            </div>
          </Item>
        </Grid>

        {/* <Grid item lg={3} md={3} sm={6} xs={12}>
          <Item
            className="cards dashGrid_item"
            onClick={() => navigate("/manage-Payments")}
          >
            <FiberNewIcon className="svg_icn" />
            <div>
              <h3>New Revenue</h3>
              <h4 className="mn_hdng">{data?.newRevenue}</h4>
            </div>
          </Item>
        </Grid> */}
      </Grid>

      <Grid container spacing={2} className="dashGraph" sx={{ pt: 4 }}>
        <Grid item lg={6} md={6} sm={6} xs={12}>
          <Item className="cards dashGraph_item">
            <h2 className="mn_hdng">
              {t.main.totalCustomers}
              <FormControl>
                <Select
                  className="select_div"
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={selectedType1}
                  onChange={handleChange}
                  inputProps={{
                    "aria-label": "Without label",
                  }}
                  displayEmpty
                >
                  <MenuItem value="" disabled>
                    Select
                  </MenuItem>
                  <MenuItem value="1">{t.main.daily}</MenuItem>
                  <MenuItem value="2">{t.main.weekly}</MenuItem>
                  <MenuItem value="3">{t.main.monthly}</MenuItem>
                  <MenuItem value="4">{t.main.yearly}</MenuItem>
                </Select>
              </FormControl>
            </h2>
            <LineChart data={graphUsersData} />
          </Item>
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={12}>
          <Item className="cards dashGraph_item">
            <h2 className="mn_hdng">
              {t.main.totalVendors}
              <FormControl>
                <Select
                  className="select_div"
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  onChange={handleChange2}
                  value={selectedType2}
                  inputProps={{
                    "aria-label": "Without label",
                  }}
                  displayEmpty
                >
                  <MenuItem value="" disabled>
                    Select
                  </MenuItem>
                  <MenuItem value="1">{t.main.daily}</MenuItem>
                  <MenuItem value="2">{t.main.weekly}</MenuItem>
                  <MenuItem value="3">{t.main.monthly}</MenuItem>
                  <MenuItem value="4">{t.main.yearly}</MenuItem>
                </Select>
              </FormControl>
            </h2>
            <LineChart data={graphVendorData} />
          </Item>
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={12}>
          <Item className="cards dashGraph_item">
            <h2 className="mn_hdng">
              {t.main.totalOrders}
              <FormControl>
                <Select
                  className="select_div"
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={selectedType3}
                  onChange={handleChange3}
                  inputProps={{
                    "aria-label": "Without label",
                  }}
                  displayEmpty
                >
                  <MenuItem value="" disabled>
                    Select
                  </MenuItem>
                  <MenuItem value="1">{t.main.daily}</MenuItem>
                  <MenuItem value="2">{t.main.weekly}</MenuItem>
                  <MenuItem value="3">{t.main.monthly}</MenuItem>
                  <MenuItem value="4">{t.main.yearly}</MenuItem>
                </Select>
              </FormControl>
            </h2>
            <LineChart data={graphOrderData} />
          </Item>
        </Grid>

        <Grid item lg={6} md={6} sm={6} xs={12}>
          <Item className="cards dashGraph_item">
            <h2 className="mn_hdng">
              {t.main.totalRevenue}
              <FormControl>
                <Select
                  className="select_div"
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={selectedType6}
                  inputProps={{
                    "aria-label": "Without label",
                  }}
                  onChange={handleChange6}
                  displayEmpty
                >
                  <MenuItem value="" disabled>
                    Select
                  </MenuItem>
                  <MenuItem value="1">{t.main.daily}</MenuItem>
                  <MenuItem value="2">{t.main.weekly}</MenuItem>
                  <MenuItem value="3">{t.main.monthly}</MenuItem>
                  <MenuItem value="4">{t.main.yearly}</MenuItem>
                </Select>
              </FormControl>
            </h2>
            <LineChart data={graphRevenueData} />
          </Item>
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={12}>
          <Item className="cards dashGraph_item">
            <h2 className="mn_hdng">
              {t.main.totalProductsListed}
              <FormControl>
                <Select
                  className="select_div"
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={selectedType3}
                  inputProps={{
                    "aria-label": "Without label",
                  }}
                  onChange={handleChange5}
                  displayEmpty
                >
                  <MenuItem value="" disabled>
                    Select
                  </MenuItem>
                  <MenuItem value="1">{t.main.daily}</MenuItem>
                  <MenuItem value="2">{t.main.weekly}</MenuItem>
                  <MenuItem value="3">{t.main.monthly}</MenuItem>
                  <MenuItem value="4">{t.main.yearly}</MenuItem>
                </Select>
              </FormControl>
            </h2>
            <LineChart data={graphProductData} />
          </Item>
        </Grid>
      </Grid>
    </div>
  );
};

export default DashBoard;
